import { M6ForecastComponent } from './components/m6-forecast.component';

import { M6ForecastDataService } from './services/m6-forecast-data.service';

import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs';

import { TranslatePipe } from '@ngx-translate/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import moment from 'moment/moment';
import { BehaviorSubject, forkJoin, Observable, of } from 'rxjs';
import { catchError, concatMap, map, throttleTime } from 'rxjs/operators';

export const MODULES = [
  CommonModule,
  MatSidenavModule,
  MatTabsModule,
  MatCardModule,
  MatButtonModule,
];
export const COMPONENTS = [FaIconComponent, M6ForecastComponent];
export const PIPES = [TranslatePipe];
@Component({
  selector: 'app-m6',
  templateUrl: './m6.component.html',
  styleUrls: ['./m6.component.scss'],
  imports: [...MODULES, ...COMPONENTS, ...PIPES],
})
export class M6Component {
  private fds = inject(M6ForecastDataService);

  private selectedTabIndexSubject = new BehaviorSubject<number>(0);

  // MAJ 10:30
  imageUrlsMAJ1030 = [
    'https://wm-custom-shared.s3.eu-west-1.amazonaws.com/einsatzwetter/m6/maps/M6_Temp_J0_AM.jpg',
    'https://wm-custom-shared.s3.eu-west-1.amazonaws.com/einsatzwetter/m6/maps/M6_Temp_J0_PM.jpg',
  ];

  // MAJ 11:30
  forecastImageUrlsMAJ1130 = [
    'https://wm-custom-shared.s3.eu-west-1.amazonaws.com/einsatzwetter/m6/maps/M6_Temp_J1_AM.jpg',
    'https://wm-custom-shared.s3.eu-west-1.amazonaws.com/einsatzwetter/m6/maps/M6_Temp_J1_PM.jpg',
  ];

  trendImageUrlsMAJ1130 = [
    'https://wm-custom-shared.s3.eu-west-1.amazonaws.com/einsatzwetter/m6/maps/M6_Temp_J2_J3_J4.jpg',
    'https://wm-custom-shared.s3.eu-west-1.amazonaws.com/einsatzwetter/m6/maps/M6_Temp_J5_J6_J7.jpg',
  ];

  // SOURCE STREAMS
  private loadMAJ1030DataSubject = new BehaviorSubject<boolean>(true);

  private loadMAJ1130DataSubject = new BehaviorSubject<boolean>(true);

  // STREAMS
  forecastTextMAJ1030$: Observable<
    Array<{ prescribe_at: string; text: string }>
  > = this.loadMAJ1030DataSubject.pipe(
    throttleTime(300000), // allow to request data only every 5min
    map(value =>
      [12, 15].map(hour => this.generateTimestampsForRequest(hour, 0))
    ), // times to request for MAJ1
    concatMap(hours =>
      forkJoin(...hours.map(hour => this.fds.getM6ForecastData(hour)))
    ),
    catchError(err => {
      console.error('error requesting m6 text data for mis a jour 10:30');
      return of([]);
    })
  );

  forecastTextMAJ1130$: Observable<
    Array<{ prescribe_at: string; text: string }>
  > = this.loadMAJ1130DataSubject.pipe(
    throttleTime(300000), // allow to request data only every 5min
    map(value =>
      [6, 15].map(hour => this.generateTimestampsForRequest(hour, 1))
    ), // times to request for MAJ2
    concatMap(hours =>
      forkJoin(...hours.map(hour => this.fds.getM6ForecastData(hour)))
    ),
    catchError(err => {
      console.error('error requesting m6 text data for mis a jour 11:30');
      return of([]);
    })
  );

  trendTextMAJ1130$: Observable<Array<{ id: number; text: string }>> =
    this.loadMAJ1130DataSubject.pipe(
      throttleTime(300000), // allow to request data only every 5min
      map(value => [234, 567]), // trend data to request
      concatMap(trendDays =>
        forkJoin(
          ...trendDays.map(days => this.fds.getM6ForecastTrendData(days))
        )
      ),
      catchError(err => {
        console.error('error requesting m6 trend data for mis a jour 11:30');
        return of([]);
      })
    );

  generateTimestampsForRequest(
    hourToGenerateTimestampFor: number,
    daysToAdd: number
  ): string {
    // should return a timestamp of current day with the hourToGenerateTimestampFor set e.g.: hourToGenerateTimestampFor = 12 --> result: 2022-09-09T12:00:00Z
    return moment()
      .add(daysToAdd, 'days')
      .utc()
      .set({
        hour: hourToGenerateTimestampFor,
        minute: 0,
        second: 0,
        millisecond: 0,
      })
      .toISOString()
      .replace('.000', '');
  }

  onTabChange(selectedTabIndex: number): void {
    // 0 --> first tab, 1 --> second tab
    this.selectedTabIndexSubject.next(selectedTabIndex);
    this.triggerReloadOfData(selectedTabIndex);
  }

  triggerReloadOfData(selectedTabIndex: number): void {
    if (selectedTabIndex === 1) {
      this.loadMAJ1030DataSubject.next(true);
    }
    if (selectedTabIndex === 2) {
      this.loadMAJ1130DataSubject.next(true);
    }
  }

  goToLink(url: string): void {
    window.open(url, '_blank');
  }
}
